import { render, staticRenderFns } from "./PackagingTypesCheckbox.vue?vue&type=template&id=4f2ac62b&"
import script from "./PackagingTypesCheckbox.vue?vue&type=script&lang=js&"
export * from "./PackagingTypesCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports